export type ItemProps = {
  label: string | JSX.Element;
  value: string;
};

export const statusOptions: ItemProps[] = [
  {
    label: 'Действующие',
    value: 'active',
  },
  {
    label: 'В архиве',
    value: 'deleted',
  },
];
